export default __webpack_public_path__ + "static/ian-8dae95b51be740c0bd1b89d91228c527.jpg";